module.exports = __webpack_public_path__ + "static/img/2New.131f29d4.png";